<script>
    import { Image } from 'smelte'
    import { createEventDispatcher } from 'svelte'

    const dispatch = createEventDispatcher()

    export let trackingID
    export let active = true
    export let ref = '#'
    export let type = 'component'
    export let title = 'Awesome App'
    export let details = ''
    export let pic = 'icon_254_information.svg'
    export let width = 100
    export let height = 25

    function navigate () {
        dispatch('navigate', {type, ref})
    }
</script>

<div data-tracking={trackingID} class="relative">
    <div class="w-full cursor-pointer select-none" on:click={navigate} >
        <div class="flex flex-row justify-items-start">
            <Image src="static/img/{pic}" alt="{pic}" height={height} width={height} />
            <span class="flex-grow ml-5 font-light tracking-wider text-left" style="font-size: 18px">{title}</span>
        </div>
    </div>
</div>
